import mapValues from 'lodash/mapValues';
import dayjs from 'dayjs';
import * as WeekMap from '../WeekMap';
import * as TimeInterval from '../TimeInterval';
import * as WeekDay from '../WeekDay';
import * as DateString from '../DateString';
import * as DayMap from '../DayMap';
export const fromSchedule = ({ schedule, dateFrom, dateTo, }) => fromWeekMap({ weekMap: WeekMap.fromSchedule(schedule), dateFrom, dateTo });
export const fromWeekMap = ({ dateFrom, dateTo, weekMap, }) => {
    const dateFromObject = dayjs.utc(dateFrom);
    const dateToObject = dayjs.utc(dateTo).isBefore(dateFrom)
        ? dateFromObject
        : dayjs.utc(dateTo);
    const calendar = {};
    for (let date = dateFromObject; date.isSameOrBefore(dateToObject); date = date.add(1, 'd')) {
        const weekDay = WeekDay.fromNum(
        // dayjs counts days from Sunday instead of Monday
        WeekDay.numPrev(date.day()));
        calendar[DateString.fromDate(date)] = { schedule: weekMap[weekDay] };
    }
    return calendar;
};
export const fromDayMap = (attrs) => mapValues(DayMap.prune(attrs), (intervals) => ({
    schedule: TimeInterval.normalizeList(intervals),
}));
export const getScheduleFromCalendarForDate = (date, calendar) => {
    const day = dayjs(date);
    const offset = day.utcOffset();
    const dateWithOffset = day.minute(offset);
    return calendar[DateString.fromDate(dateWithOffset)]?.schedule ?? [];
};
//# sourceMappingURL=converters.js.map